module.exports = "<div *ngIf=\"message != null\" class=\"notification\">\n    {{message}}\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/message-notification/message-notification-component.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/message-notification/message-notification-component.html
// module chunks = 1